// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._154iidpf{top:0}
._18m91wug{overflow-y:auto}
._1bsb1osq{width:100%}
._1ltvidpf{left:0}
._1reo15vq{overflow-x:hidden}
._kqswstnw{position:absolute}
._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}
._1hvw1o36:focus{outline-width:medium}
._49pcglyw:focus{outline-style:none}
._nt751r31:focus{outline-color:currentColor}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/picker/VirtualList.compiled.css"],"names":[],"mappings":"AAAA,WAAW,KAAK;AAChB,WAAW,eAAe;AAC1B,WAAW,UAAU;AACrB,WAAW,MAAM;AACjB,WAAW,iBAAiB;AAC5B,WAAW,iBAAiB;AAC5B,WAAW,sCAAsC;AACjD,iBAAiB,oBAAoB;AACrC,iBAAiB,kBAAkB;AACnC,iBAAiB,0BAA0B","sourcesContent":["._154iidpf{top:0}\n._18m91wug{overflow-y:auto}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._1reo15vq{overflow-x:hidden}\n._kqswstnw{position:absolute}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._1hvw1o36:focus{outline-width:medium}\n._49pcglyw:focus{outline-style:none}\n._nt751r31:focus{outline-color:currentColor}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
